class GaPeekGallery {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.product__media-list');
    if (!this.track) return;

    this.originalSlides = Array.from(this.track.children);
    this.slideCount = this.originalSlides.length;
    if (this.slideCount < 2) return; // tek görsel varsa loop'a gerek yok

    // Sonsuz döngü için: son slide'ın kopyasını başa, ilk slide'ın kopyasını sona ekle
    this.firstClone = this.originalSlides[0].cloneNode(true);
    this.lastClone = this.originalSlides[this.slideCount - 1].cloneNode(true);
    this.firstClone.setAttribute('aria-hidden', 'true');
    this.lastClone.setAttribute('aria-hidden', 'true');
    this.track.insertBefore(this.lastClone, this.originalSlides[0]);
    this.track.appendChild(this.firstClone);

    this.slides = Array.from(this.track.children); // [lastClone, ...orijinaller, firstClone]
    this.index = 1; // 1. gerçek slide'dan başla (0. index klon)
    this.animating = false;

    this.prevBtn = root.querySelector('.slider-button--prev');
    this.nextBtn = root.querySelector('.slider-button--next');
    this.counterCurrent = root.querySelector('.slider-counter--current');
    this.counterTotal = root.querySelector('.slider-counter--total');

    if (this.counterTotal) this.counterTotal.textContent = this.slideCount;
    this.updateCounter();
    this.setPosition(false);

    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
    this.track.addEventListener('transitionend', () => this.handleTransitionEnd());
  }

  slideWidthPercent() {
    const value = getComputedStyle(this.root).getPropertyValue('--ga-slide-width');
    return parseFloat(value) || 100;
  }

  go(direction) {
    if (this.animating) return;
    this.animating = true;
    this.index += direction;
    this.setPosition(true);
    this.updateCounter();
  }

  setPosition(animate) {
    this.track.style.transition = animate ? '' : 'none';
    const width = this.slideWidthPercent();
    this.track.style.transform = `translateX(-${this.index * width}%)`;
    if (!animate) {
      // reflow zorla, sonraki transition'ın anında uygulanmasını engelle
      void this.track.offsetHeight;
      this.track.style.transition = '';
    }
  }

  handleTransitionEnd() {
    this.animating = false;
    if (this.index === this.slides.length - 1) {
      // son (klon) slide'a gelindi → gerçek ilk slide'a anında (animasyonsuz) atla
      this.index = 1;
      this.setPosition(false);
    } else if (this.index === 0) {
      // baştaki klona gelindi → gerçek son slide'a anında atla
      this.index = this.slides.length - 2;
      this.setPosition(false);
    }
  }

  updateCounter() {
    if (!this.counterCurrent) return;
    let realIndex = this.index;
    if (realIndex === 0) realIndex = this.slideCount;
    if (realIndex === this.slides.length - 1) realIndex = 1;
    this.counterCurrent.textContent = realIndex;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Desktop only. Below 750px, Dawn's own native slider (already loaded,
  // already wired to the same .slider-button--prev/next + counter
  // markup) handles the gallery correctly on its own — this class's
  // clone-and-transform loop was fighting it for control of the same
  // .product__media-list, and on load immediately shifted the track by
  // one full slide-width to skip its prepended clone, which is exactly
  // what pushed the real first image out of view on mobile (blank/white
  // gallery, arrows still visible since those are unrelated markup).
  if (window.innerWidth >= 750) {
    document.querySelectorAll('[data-ga-peek-gallery]').forEach((el) => new GaPeekGallery(el));
    return;
  }

  // Mobile: "Dawn's own native slider" above assumed the gallery viewer
  // was a <slider-component> (Dawn's custom element that wires prev/next
  // BUTTON clicks to a scroll). It isn't — it's a plain <div
  // data-ga-peek-gallery>, kept that way on purpose so desktop's
  // GaPeekGallery (above) doesn't fight Dawn's slider-component for the
  // same list. That means on mobile NOTHING was ever wiring the arrow
  // buttons to anything: native touch-swipe/scroll-snap on
  // .product__media-list still worked, but clicking the buttons did
  // nothing. This fills in just that one missing behavior.
  document.querySelectorAll('[data-ga-peek-gallery]').forEach((root) => {
    const list = root.querySelector('.product__media-list');
    const prevBtn = root.querySelector('.slider-button--prev');
    const nextBtn = root.querySelector('.slider-button--next');
    if (!list) return;

    const originalSlides = Array.from(list.querySelectorAll('.slider__slide'));
    if (originalSlides.length < 2) return;

    // A plain scrollTo(realFirst/realLast) always wraps by scrolling
    // BACKWARD across the whole list — pressing "next" at the last photo
    // visibly slides the first photo in from the LEFT, the wrong
    // direction. Same clone trick GaPeekGallery uses on desktop: a clone
    // of the first slide appended after the last (and vice versa) lets
    // "next" keep scrolling rightward through the wrap, then — once that
    // scroll finishes — silently (no animation) snaps scrollLeft back to
    // the real slide at the same visual position. Mirrored for "prev".
    const firstClone = originalSlides[0].cloneNode(true);
    const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    list.insertBefore(lastClone, originalSlides[0]);
    list.appendChild(firstClone);

    const slides = Array.from(list.querySelectorAll('.slider__slide')); // [lastClone, ...real, firstClone]
    const realStart = 1;
    const realEnd = slides.length - 2;

    // component-slider.css sets scroll-behavior:smooth on .slider, which
    // means the browser owns/animates any scrollLeft change on its own
    // timeline. Trying to silently correct a clone landing right as that
    // native animation finishes (via the 'scrollend' event) fought the
    // browser's own in-flight animation and produced a visible stutter.
    // Overriding it to 'auto' here hands ALL scroll animation to our own
    // requestAnimationFrame loop below instead — fully our own timeline,
    // so we know exactly when it starts and ends. Manual touch-swipe
    // dragging is native browser behavior and is unaffected by this
    // property either way, so it stays as smooth as before.
    list.style.scrollBehavior = 'auto';

    function jumpTo(i) {
      list.scrollLeft = slides[i].offsetLeft;
    }

    jumpTo(realStart);

    // Position is read from the SCROLL ITSELF, not a variable updated
    // only on button clicks — a manually swiped drag never touched such
    // a variable, so after a swipe or two the next button click was
    // scrolling to a stale, wrong target.
    function nearestIndex() {
      let closest = realStart;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - list.scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    let isAnimating = false;
    let rafId = null;

    function animateTo(targetIndex, onDone) {
      if (rafId) cancelAnimationFrame(rafId);
      isAnimating = true;
      const startLeft = list.scrollLeft;
      const endLeft = slides[targetIndex].offsetLeft;
      const change = endLeft - startLeft;
      const duration = 350;
      const startTime = performance.now();

      function step(now) {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        list.scrollLeft = startLeft + change * eased;
        if (t < 1) {
          rafId = requestAnimationFrame(step);
        } else {
          isAnimating = false;
          rafId = null;
          if (onDone) onDone();
        }
      }
      rafId = requestAnimationFrame(step);
    }

    function goTo(direction) {
      const next = nearestIndex() + direction;
      animateTo(next, () => {
        if (next === slides.length - 1) {
          jumpTo(realStart);
        } else if (next === 0) {
          jumpTo(realEnd);
        }
      });
    }

    if (nextBtn) nextBtn.addEventListener('click', () => goTo(1));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(-1));

    // Manual swipe/drag wrap-around: our own animation above already
    // handles button presses, so this only needs to catch native
    // touch-scroll settling — guarded against firing mid-button-animation.
    let settleTimer = null;
    list.addEventListener(
      'scroll',
      () => {
        if (isAnimating) return;
        clearTimeout(settleTimer);
        settleTimer = setTimeout(() => {
          const i = nearestIndex();
          if (i === slides.length - 1) jumpTo(realStart);
          else if (i === 0) jumpTo(realEnd);
        }, 120);
      },
      { passive: true }
    );
  });
});
